import React, { useContext, useEffect, useState } from "react";
import { message, Upload, Popover } from "antd";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import uploadimg from "../../assets/uploadicon.svg";
import eye from "../../assets/viewPdfEyeIcon.svg";
import deleteicon from "../../assets/deleteicon.svg";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field } from "formik";
import { fileUploadAction } from "../../redux/action/fileUpload";
import {
  addProductFeatureAction,
  addProductFeaturesHandler,
} from "../../redux/action/addProductFeaturesSlice";
import { getProductFeaturesAction } from "../../redux/action/getproductFeaturesSlice";
import { BrandChangeModal } from "../../components/BrandChangeModal/BrandChangeModal";
import { convert } from "html-to-text";
import { getProductFeatureContentHandler } from "../../redux/action/getProductFeatureContentSlice";
import { useCommonMessage } from "../../common/CommonMessage";
import axios from "axios";
import {
  BtnBold,
  BtnBulletList,
  BtnItalic,
  BtnNumberedList,
  BtnStrikeThrough,
  BtnUnderline,
  Editor,
  EditorProvider,
  HtmlButton,
  Toolbar,
} from "react-simple-wysiwyg";
import { API_URL } from "../../services/http";
import {
  BtnAlignCenter,
  BtnAlignLeft,
  BtnAlignRight,
  BtnImageUpload,
  BtnSubscript,
  BtnSuperscript,
} from "../Html_Editor/BtnFontFamily";
import { ThemeContext } from "../../common/themeContext";
import { DraggerPayload } from "./DraggerPayload";
import Loader from "../Loder/loader";
import { getItem } from "../../common/localStorage";
import infoicon from "../../assets/infoicon.svg";
import ProductPermissionDenied, {
  hasDraggerHtmlContent,
  hasUnsavedDraggerHtml,
  ViewOnlyHtmlContent,
} from "./ProductPermissionDenied";
import {
  useAdminPermissions,
  canDeleteProductFiles,
  PRODUCT_PERMISSION_MESSAGES,
} from "../../hooks/useAdminPermissions";

const Dragger = ({
  deleteUploadedFile,
  setDeleteUploadedFile,
  state,
  onlyHtmlEditer,
  onContentChange,
  onContentChangeSpanish,
  initialHtml,
  initialHtmlSpanish,
  hideSaveButton = false,
  documentName = '',
  onBeforeSave,
}) => {
  const [addProductFeatureModal, setAddProductFeatureModal] = useState(false);
  const [manageSwitch, setManageSwitch] = useState(false);
  const [handleSwitchToast, setHandleSwitchToast] = useState(false);
  const [fileUploaded, setFileUploaded] = useState("");
  const [spanishFileUpload, setSpanishFileUpload] = useState("");
  const [plainText, setPlainText] = useState("");
  const [plainTextSpanish, setPlaintextSpanish] = useState("");
  const [loading, setLoading] = useState(false);
  const [englishText, setEnglishText] = useState("");
  const [spanishText, setSpanishText] = useState("");
  const [infoPopoverVisible, setInfoPopoverVisible] = useState(false);

  const messageApi = useCommonMessage();
  const dispatch = useDispatch();
  const fileUploadDataSelector = useSelector((state) => state?.fileUploadData);
  const { hasProductViewOnly, permissionGroups } = useAdminPermissions();
  const isProductViewOnly = !onlyHtmlEditer && hasProductViewOnly;
  const showDeleteButton = canDeleteProductFiles(permissionGroups);
  const addProductFeaturesSelector = useSelector(
    (state) => state?.addProductFeatures
  );
  const getProductFeatureSelector = useSelector(
    (state) => state?.getProductFeatureContentMain
  );

  let getProductData = getProductFeatureSelector?.data?.data;
  let fileUploadData = fileUploadDataSelector?.data?.data;
  const englishHtmlContent =
    getProductData?.content?.english?.html?.html_content ?? plainText;
  const spanishHtmlContent =
    getProductData?.content?.spanish?.html?.html_content ?? plainTextSpanish;

  const getAdminLoginId = getItem("adminId");
  const { brandId } = useContext(ThemeContext);

  // Reset Actions
  const resetActions = () => {
    dispatch(fileUploadAction.fileUploadInfoReset());
    dispatch(addProductFeatureAction.addProductFeaturesInfoReset());
    dispatch(getProductFeaturesAction.getProductFeaturesInfoReset());
  };

  const { Dragger } = Upload;

  const props = {
    name: "file",
    multiple: false,
    accept: ".pdf",
    showUploadList: false,
    async beforeUpload(file) {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        message.error("You can only upload PDF files!");
        setFileUploaded("");
        return false;
      }
      const isSizeAccepted = file.size / 1024 / 1024 <= 10;
      if (!isSizeAccepted) {
        message.error("File size exceeds 10MB limit!");
        setFileUploaded("");
        return false;
      }
      if (isPDF && isSizeAccepted) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", Number(getAdminLoginId));
        formData.append("brandId", brandId);
        formData.append(
          "path",
          `${"product/" + getProductFeatureSelector?.data?.data?.productCode}/${state?.item?.featureName
          }/${manageSwitch === false ? "English" : "Spanish"}`
        );
        setLoading(true);
        axios
          .post(API_URL + "/file/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response) => {
            dispatch(fileUploadAction.fileUploadInfoSuccess(response.data));
            if (manageSwitch === false) {
              setFileUploaded(file?.name);
            } else {
              setSpanishFileUpload(file?.name);
            }
          })
          .catch((error) => {
            console.error("Error uploading file:", error);
            dispatch(fileUploadAction.fileUploadInfoFailure(error));
          })
          .finally(() => {
            setLoading(false);
          });
        if (manageSwitch === false) {
          setFileUploaded(file?.name);
        } else {
          setSpanishFileUpload(file?.name);
        }
      }
      return false;
    },
  };

  const handleCancel = () => {
    setAddProductFeatureModal(false);
  };

  // Delete Modal Functionality
  const handleModalYes = () => {
    if (manageSwitch === false) {
      setAddProductFeatureModal(false);
      setFileUploaded("");
      resetActions();
      let payload = {
        productId: getProductData?.productId,
        featureId: getProductData?.refFeatureId,
        content: {
          html: false,
          english: {
            file: {
              url: "",
              name: "",
              isTrue: true,
              preSigned: "",
            },
            html: {
              isTrue: true,
              html_content: "",
            },
          },
          pdf_url: true,
          spanish: {
            file: {
              url: getProductData?.content?.spanish?.file?.url || "",
              name: getProductData?.content?.spanish?.file?.name || "",
              isTrue: getProductData?.content?.spanish?.file?.isTrue || true,
              preSigned: getProductData?.content?.spanish?.file?.preSigned,
            },
            html: {
              isTrue: true,
              html_content: "",
            },
          },
        },
      };
      dispatch(addProductFeaturesHandler(payload));
    } else if (manageSwitch === true) {
      setAddProductFeatureModal(false);
      setSpanishFileUpload("");
      resetActions();
      let payload2 = {
        productId: getProductData?.productId,
        featureId: getProductData?.refFeatureId,
        content: {
          html: false,
          english: {
            file: {
              url: getProductData?.content?.english?.file?.signedUrl || "",
              name: getProductData?.content?.english?.file?.name || "",
              preSigned: getProductData?.content?.english?.file?.preSigned,
              isTrue: true,
            },
            html: {
              isTrue: true,
              html_content: "",
            },
          },
          pdf_url: true,
          spanish: {
            file: {
              url: "",
              name: "",
              isTrue: true,
              preSigned: "",
            },
            html: {
              isTrue: true,
              html_content: "",
            },
          },
        },
      };
      dispatch(addProductFeaturesHandler(payload2));
    }
  };

  const deleteFile = () => {
    setAddProductFeatureModal(true);
    setDeleteUploadedFile("DeleteFile");

  };
  const handleFormSubmit = (values, formikBag) => {
    if (!window.location.pathname.includes('manage-release-document')) {
      DraggerPayload({
        manageSwitch,
        getProductData,
        fileUploadData,
        values,
        plainText,
        fileUploaded,
        plainTextSpanish,
        spanishFileUpload,
        dispatch,
      });
    }
    // Block any API call if documentName is blank
    else if (!documentName || documentName.trim() === '') {
      if (typeof onBeforeSave === 'function') {
        onBeforeSave(values, formikBag); // ensure error set in parent
      }
      return; // Hard block
    }
    // If an onBeforeSave prop exists, allow it to block submission
    else if (typeof onBeforeSave === 'function') {
      const continueSave = onBeforeSave(values, formikBag);
      if (continueSave === false) {
        return; // Block actual save
      }
    }
    // Block API call for both manage-release-documents and manage-release-document


  };


  useEffect(() => {
    if (fileUploadData) {
      messageApi.open({
        type: "success",
        content: fileUploadDataSelector?.data?.message,
      });
      setHandleSwitchToast(true);
    }
  }, [fileUploadDataSelector]);

  useEffect(() => {
    if (addProductFeaturesSelector?.data?.data) {
      messageApi.open({
        type: "success",
        content: addProductFeaturesSelector?.data?.message,
      });
      setEnglishText("")
      setSpanishText("")
      dispatch(addProductFeatureAction.addProductFeaturesInfoReset());
      let payload1 = {
        productId: getProductData?.productId,
        refFeatureId: getProductData?.refFeatureId,
      };
      dispatch(getProductFeatureContentHandler(payload1));
    }
  }, [addProductFeaturesSelector]);

  const handleEnglishSwitch = () => {
    if (isProductViewOnly) {
      setManageSwitch(false);
      return;
    }

    if (handleSwitchToast && fileUploadData) {
      messageApi.open({
        type: "warning",
        content: "Please Save File First!!",
      });
      setManageSwitch(true);
    } else if (
      hasUnsavedDraggerHtml(
        spanishText,
        getProductData?.content?.spanish?.html?.html_content,
      )
    ) {
      messageApi.open({
        type: "warning",
        content: "Please Save HTML First!!",
      });
    } else {
      setManageSwitch(false);
    }
  };

  const handleSpanishSwitch = () => {
    if (isProductViewOnly) {
      setManageSwitch(true);
      return;
    }

    if (handleSwitchToast && fileUploadData) {
      messageApi.open({
        type: "warning",
        content: "Please Save File First!!",
      });
      setManageSwitch(false);
    } else if (
      hasUnsavedDraggerHtml(
        englishText,
        getProductData?.content?.english?.html?.html_content,
      )
    ) {
      messageApi.open({
        type: "warning",
        content: "Please Save HTML First!!",
      });
    } else {
      setManageSwitch(true);
    }
  };
  useEffect(() => {
    // Initialize editor content from props when provided (e.g., Manage flow)
    if (onlyHtmlEditer) {
      if (typeof initialHtml === "string") {
        setPlainText(initialHtml);
        setEnglishText(initialHtml);
      }
      if (typeof initialHtmlSpanish === "string") {
        setPlaintextSpanish(initialHtmlSpanish);
        setSpanishText(initialHtmlSpanish);
      }
    }
  }, [initialHtml, initialHtmlSpanish, onlyHtmlEditer]);

  useEffect(() => {
    if (onlyHtmlEditer) return;

    const englishHtml = getProductData?.content?.english?.html?.html_content;
    const spanishHtml = getProductData?.content?.spanish?.html?.html_content;

    if (typeof englishHtml === "string") {
      setPlainText(englishHtml);
      setEnglishText(englishHtml);
    }

    if (typeof spanishHtml === "string") {
      setPlaintextSpanish(spanishHtml);
      setSpanishText(spanishHtml);
    }
  }, [getProductData, onlyHtmlEditer]);

  const onChange = (e) => {
    setPlainText(e.target.value);
    setEnglishText(e.target.value);
    if (typeof onContentChange === 'function') {
      onContentChange(e.target.value);
    }
  };
  const onChangeSpanish = (e) => {
    setPlaintextSpanish(e.target.value);
    setSpanishText(e.target.value);
    if (typeof onContentChangeSpanish === 'function') {
      onContentChangeSpanish(e.target.value);
    }
  };

  const infoContent = (
    <div style={{ maxWidth: '400px' }}>
      Use only the supported variable format for placeholders: %userName%, %dateOfBirth%, %memberId%, %date%, %day%, %month%, %year%.
      <br />
      <br />
      For signature, use the following format:
      <br />
      {"<img src='%signature%' width= '70px'>"}<br />
      <br />
      These variables will be automatically replaced with the corresponding values when the template is generated.
    </div>
  );

  return (
    <>
      {(loading === true ||
        addProductFeaturesSelector?.isLoading === true ||
        getProductFeatureSelector?.isLoading === true) && (
          <Loader loaderTransForm="loaderTransForm" />
        )}
      {!onlyHtmlEditer && (
          <div className="switches-container mb-30">
            <div className="mempro" onClick={handleEnglishSwitch}>
              English
            </div>
            <div className="mempro" onClick={handleSpanishSwitch}>
              Spanish
            </div>
            <div
              className={
                !manageSwitch ? "switch-wrapper" : "switch-wrapper switchside"
              }
            >
              <div className="switch">
                {!manageSwitch ? <div>English</div> : <div>Spanish</div>}
              </div>
            </div>
          </div>
      )}
      <Formik
        enableReinitialize
        initialValues={{
          file_upload: "",
          html_editor: plainText || "",
          html_editor_spanish: plainTextSpanish || "",
        }}
        onSubmit={handleFormSubmit}
      >
        {({ isSubmitting, setFieldValue, values }) => (
          <Form>
            <div className={`table-padding tabbing mb-40 btnPosition ${onlyHtmlEditer && 'emailtemplatePosition'}`}>
              {manageSwitch === false ? (
                <Tabs
                  defaultActiveKey={onlyHtmlEditer ? "profile" : "home"}
                  id="uncontrolled-tab-example"
                  className=""
                >
                  {!onlyHtmlEditer && (
                    <Tab eventKey="home" title="Upload File">
                      {isProductViewOnly ? (
                        fileUploaded ||
                        getProductData?.content?.english?.file?.url ? (
                          <div className="ant-upload-list ant-upload-list-text">
                            <span className="ant-upload-list-item-container">
                              <div className="d-flex gap-2 align-items-center file-icon">
                                <img src={uploadimg} alt="" />
                                {fileUploaded ||
                                  getProductData?.content?.english?.file?.name}
                              </div>
                              <div className="d-flex gap-2 align-items-center">
                                <a
                                  href={
                                    fileUploadData?.signedUrl ||
                                    getProductData?.content?.english?.file?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img src={eye} alt="" />
                                </a>
                              </div>
                            </span>
                          </div>
                        ) : (
                          <ProductPermissionDenied
                            message={PRODUCT_PERMISSION_MESSAGES.UPLOAD}
                          />
                        )
                      ) : convert(plainText) !== "" &&
                        convert(plainText).trim() !== "" ? (
                        <div className="removehtml">
                          Please Remove HTML in HTML Editor
                        </div>
                      ) : (
                        <div>
                          {!(
                            fileUploaded ||
                            getProductData?.content?.english?.file?.url
                          ) ? (
                            <>
                              <Field name="file_upload">
                                {({ field }) => (
                                  <Dragger {...props}>
                                    <p className="ant-upload-drag-icon">
                                      <img src={uploadimg} alt="" />
                                    </p>
                                    <p className="ant-upload-text">
                                      <u>Click here</u> or drag & drop to upload
                                      .PDF file
                                    </p>
                                  </Dragger>
                                )}
                              </Field>
                              <div className="mt-3 d-flex justify-content-between textgrey  w-100">
                                <div className="fs-16">
                                  Supported formats : PDF
                                </div>
                                <div className="fs-16">
                                  Maximum file size : 10 MB
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="ant-upload-list ant-upload-list-text">
                              <span className="ant-upload-list-item-container">
                                <div className="d-flex gap-2 align-items-center file-icon">
                                  <img src={uploadimg} alt="" />
                                  {fileUploaded ||
                                    getProductData?.content?.english?.file?.name}
                                </div>
                                <div className="d-flex gap-2 align-items-center">
                                  <a
                                    href={
                                      fileUploadData?.signedUrl ||
                                      getProductData?.content?.english?.file?.url
                                    }
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <img src={eye} alt="" />
                                  </a>
                                  {showDeleteButton && (
                                    <div
                                      onClick={deleteFile}
                                      className="cursorPointer"
                                    >
                                      <img src={deleteicon} alt="" />
                                    </div>
                                  )}
                                </div>
                              </span>
                            </div>
                          )}
                        </div>
                      )}
                      {!isProductViewOnly &&
                        fileUploadDataSelector?.data !== null && (
                        <div className="text-end">
                          <button
                            type="submit"
                            className=" sbg border-0 fw-18 gbo continuebtn savebtn disclaimerBtn"
                          >
                            Save
                          </button>
                        </div>
                      )}
                    </Tab>
                  )}
                  <Tab eventKey="profile" title="HTML Editor" >
                    {isProductViewOnly ? (
                      hasDraggerHtmlContent(englishHtmlContent) ? (
                        <ViewOnlyHtmlContent html={englishHtmlContent} />
                      ) : (
                        <ProductPermissionDenied
                          message={PRODUCT_PERMISSION_MESSAGES.HTML}
                          isHtml
                        />
                      )
                    ) : (
                      <>
                    {window.location.pathname.includes('manage-release-document') && (
                      <Popover
                        content={infoContent}
                        trigger="click"
                        open={infoPopoverVisible}
                        onOpenChange={setInfoPopoverVisible}
                        overlayClassName="custom-info-popover"
                        placement="bottomRight"
                      >
                        <div className="informativeButton" style={{ cursor: 'pointer' }}>
                          <img src={infoicon} alt="info" />
                        </div>
                      </Popover>
                    )}
                    {!(
                      fileUploadData ||
                      getProductData?.content?.english?.file?.url ||
                      getProductData?.content?.spanish?.file?.url
                    ) ? (
                      <>
                        <EditorProvider>
                          <Editor
                            value={plainText}
                            onChange={onChange}
                            className="editorContent"
                          >
                            <Toolbar>
                              <BtnBold />
                              <BtnItalic />
                              <BtnUnderline />
                              <HtmlButton />
                              <BtnBulletList />
                              <BtnNumberedList />
                              <BtnStrikeThrough />
                              <BtnAlignCenter />
                              <BtnAlignLeft />
                              <BtnAlignRight />
                              <BtnSuperscript />
                              <BtnSubscript />
                              <BtnImageUpload />
                            </Toolbar>
                          </Editor>
                        </EditorProvider>

                        <div className="mt-3 d-flex justify-content-between textgrey  w-100">
                          <div className="fs-16">
                            Note: {"</>"} Click this button before adding HTML
                            text.
                          </div>
                        </div>
                        {(!hideSaveButton && convert(plainText).trim() !== "") && (
                          <div className="text-end">
                            <button
                              type="submit"
                              className=" sbg border-0 fw-18 gbo continuebtn savebtn disclaimerBtn"
                            >
                              Save
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="removehtml">
                        Please Remove File in uploaded file
                      </div>
                    )}
                      </>
                    )}
                  </Tab>
                </Tabs>
              ) : (
                <Tabs
                  defaultActiveKey={onlyHtmlEditer ? "profile" : "home"}
                  id="uncontrolled-tab-example"
                  className=""
                >
                  {!onlyHtmlEditer && (
                    <Tab eventKey="home" title="Upload File">
                      {isProductViewOnly ? (
                        spanishFileUpload ||
                        getProductData?.content?.spanish?.file?.url ? (
                          <div className="ant-upload-list ant-upload-list-text">
                            <span className="ant-upload-list-item-container">
                              <div className="d-flex gap-2 align-items-center file-icon">
                                <img src={uploadimg} alt="" />
                                {spanishFileUpload ||
                                  getProductData?.content?.spanish?.file?.name}
                              </div>
                              <div className="d-flex gap-2">
                                <a
                                  href={
                                    fileUploadData?.signedUrl ||
                                    getProductData?.content?.spanish?.file?.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img src={eye} alt="" />
                                </a>
                              </div>
                            </span>
                          </div>
                        ) : (
                          <ProductPermissionDenied
                            message={PRODUCT_PERMISSION_MESSAGES.UPLOAD}
                          />
                        )
                      ) : (convert(plainTextSpanish) !== "" &&
                        convert(plainTextSpanish).trim() !== "") ||
                        convert(plainText)?.trim() !== "" ? (
                        <div className="removehtml">
                          Please Remove HTML in HTML Editor
                        </div>
                      ) : (
                        <div>
                          {!(
                            spanishFileUpload ||
                            getProductData?.content?.spanish?.file?.url
                          ) ? (
                            <>
                              <Field name="file_upload">
                                {({ field }) => (
                                  <Dragger {...props}>
                                    <p className="ant-upload-drag-icon">
                                      <img src={uploadimg} alt="" />
                                    </p>
                                    <p className="ant-upload-text">
                                      <u>Click here</u> or drag & drop to upload
                                      .PDF file spanish
                                    </p>
                                  </Dragger>
                                )}
                              </Field>
                              <div className="mt-3 d-flex justify-content-between textgrey  w-100">
                                <div className="fs-16">
                                  Supported formats : PDF
                                </div>
                                <div className="fs-16">
                                  Maximum file size : 10 MB
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="ant-upload-list ant-upload-list-text">
                                <span className="ant-upload-list-item-container">
                                  <div className="d-flex gap-2 align-items-center file-icon">
                                    <img src={uploadimg} alt="" />
                                    {spanishFileUpload ||
                                      getProductData?.content?.spanish?.file
                                        ?.name}
                                  </div>
                                  <div className="d-flex gap-2">
                                    <a
                                      href={
                                        fileUploadData?.signedUrl ||
                                        getProductData?.content?.spanish?.file
                                          ?.url
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <img src={eye} alt="" />
                                    </a>
                                    {showDeleteButton && (
                                      <div
                                        onClick={deleteFile}
                                        className="cursorPointer"
                                      >
                                        <img src={deleteicon} alt="" />
                                      </div>
                                    )}
                                  </div>
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                      {!isProductViewOnly &&
                        fileUploadDataSelector?.data !== null && (
                        <div className="text-end">
                          <button
                            type="submit"
                            className=" sbg border-0 fw-18 gbo continuebtn savebtn disclaimerBtn"
                          >
                            Save
                          </button>
                        </div>
                      )}
                    </Tab>
                  )}
                  <Tab eventKey="profile" title="HTML Editor">
                    {isProductViewOnly ? (
                      hasDraggerHtmlContent(spanishHtmlContent) ? (
                        <ViewOnlyHtmlContent html={spanishHtmlContent} />
                      ) : (
                        <ProductPermissionDenied
                          message={PRODUCT_PERMISSION_MESSAGES.HTML}
                          isHtml
                        />
                      )
                    ) : (
                      <>
                    {window.location.pathname.includes('manage-release-document') && (
                      <Popover
                        content={infoContent}
                        trigger="click"
                        open={infoPopoverVisible}
                        onOpenChange={setInfoPopoverVisible}
                        overlayClassName="custom-info-popover"
                        placement="bottomRight"
                      >
                        <div className="informativeButton" style={{ cursor: 'pointer' }}>
                          <img src={infoicon} alt="info" />
                        </div>
                      </Popover>
                    )}
                    {!(
                      fileUploadData ||
                      getProductData?.content?.spanish?.file?.url ||
                      getProductData?.content?.english?.file?.url
                    ) ? (
                      <>
                        <EditorProvider>
                          <Editor
                            value={plainTextSpanish}
                            onChange={onChangeSpanish}
                          >
                            <Toolbar>
                              <BtnBold />
                              <BtnItalic />
                              <BtnUnderline />
                              <HtmlButton />
                              <BtnBulletList />
                              <BtnNumberedList />
                              <BtnStrikeThrough />
                              <BtnAlignCenter />
                              <BtnAlignLeft />
                              <BtnAlignRight />
                              <BtnSuperscript />
                              <BtnSubscript />
                              <BtnImageUpload />
                            </Toolbar>
                          </Editor>
                        </EditorProvider>
                        <div className="mt-3 d-flex justify-content-between textgrey  w-100">
                          <div className="fs-16">
                            Note: {"</>"} Click this button before adding HTML
                            text.
                          </div>
                        </div>
                        {(!hideSaveButton && convert(plainTextSpanish).trim() !== "") && (
                          <div className="text-end">
                            <button
                              type="submit"
                              className="sbg border-0 fw-18 gbo continuebtn savebtn disclaimerBtn"
                            >
                              Save
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="removehtml">
                        Please Remove File in uploaded file
                      </div>
                    )}
                      </>
                    )}
                  </Tab>
                </Tabs>
              )}
            </div>
          </Form>
        )}
      </Formik>
      {addProductFeatureModal && (
        <BrandChangeModal
          addProductFeatureModal={addProductFeatureModal}
          handleCancel={handleCancel}
          handleModalYes={handleModalYes}
          deleteUploadedFile={deleteUploadedFile}
        />
      )}
    </>
  );
};

export default Dragger;
